
import React, { useEffect, useRef } from 'react';
import { Link, } from "react-router-dom";

const Navbar = () => {
  // useEffect(() => {
    
   

  
 

  //   // // Add scroll event listener for navbar shadow
  //   window.addEventListener("scroll", () => {
  //     const navbar = document.querySelector(".navbar");
  //     if (window.scrollY > 50) {
  //       navbar.classList.add("shadow");
  //     } else {
  //       navbar.classList.remove("shadow");
  //     }
  //   });

  //   return () => {
  //     window.removeEventListener("scroll", () => {});
  //   };
  // }, []);

  const navToggleRef = useRef(null);
  const navbarNavRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navToggleRef.current && !navToggleRef.current.contains(event.target) &&
        navbarNavRef.current && !navbarNavRef.current.contains(event.target)
      ) {
        navbarNavRef.current.classList.remove('show');
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    
  //   <header>
  //   <nav>
  //     <div className="logo"><Link to="/">CloudMinds</Link></div>
     
  //     <div className="menu-toggle" id="mobile-menu" onClick={toggleMenu}>
  //       <span className="bar"></span>
  //       <span className="bar"></span>
  //       <span className="bar"></span>
  //     </div>
  //     <ul className={`nav-links ${menuActive ? 'active' : ''}`} id="nav-links">
  //       <li><Link to="/" onClick={closeMenu}>Home</Link></li>
  //       <li><Link to="/service" onClick={closeMenu}>Services</Link></li>
  //       <li><Link to="/technologies" onClick={closeMenu}>Technologies</Link></li>
  //       {/* <li><Link to="/" onClick={closeMenu}>Industries</Link></li>
  //       <li><Link to="/" onClick={closeMenu}>Who we are</Link></li> */}

  //       {/* <li><Link to="/about" onClick={closeMenu}>About</Link></li>
  //       <li><Link to="/technologies" onClick={closeMenu}>Technologies</Link></li>
  //       <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li> */}
  //     </ul>
     
  //   </nav>
  // </header>

//   <nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top">
//   <div class="container p-0">
//   <Link className="navbar-brand" to="/">ColudMinds</Link>
//     <div
//       class="collapse navbar-collapse d-flex align-items-center justify-content-center"
//       id="navbarNav"
//     >
//       <ul class="navbar-nav">
//         <li class="nav-item">
//         <Link className="nav-link" to="/service"
//                 >Services</Link
//               >
//         </li>
//         <li class="nav-item">
//         <Link className="nav-link" to="/technologies">Technologies</Link>
//         </li>
//         <li class="nav-item">
//         <Link className="nav-link" to="/industries">Industries</Link>
//         </li>
//         <li class="nav-item">
//         <Link className="nav-link" to="/about">Who we are</Link>
//         </li>
//       </ul>
//     </div>
//     <div class="cloudmins-btn">Schedule a meeting</div>
//   </div>
// </nav>
<nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
      <div className="container p-12">
        <Link className="navbar-brand" to="/">ColudMinds</Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" ref={navToggleRef}>
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse align-items-center justify-content-center" id="navbarNav" ref={navbarNavRef}>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/service">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/technologies">Technologies</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/industries">Industries</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">Who we are</Link>
            </li>
            <li>
              <div className="cloudmins-btn">Schedule a meeting</div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  
  )
}

export default Navbar
